import React, { useState } from "react";

const Page24 = () => {

  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <div style={{paddingTop: '100px'}}>
      <div
        className="col-md-12 fontS-18"
        style={{ marginBottom: 40, paddingBottom: 5 }}
      >
        <p>
          Ao observar o fluxograma do MOC, você percebe que o processo não segue sempre em linha reta. Em alguns pontos, ele para e faz uma pergunta importante: a mudança pode avançar ou precisa de ajustes? 
        </p>

        <p>Esses momentos aparecem, por exemplo, quando é preciso:</p>
      </div>


      {/* Caixa de destaque */}
      <div
        style={{
          backgroundColor: "#e9ffcd",
          borderLeft: "6px solid #89D127",
          padding: "25px",
          borderRadius: "6px",
          color: "#0f8504",
          fontSize: "18px",
          lineHeight: "1.6",
          marginBottom: 40,
        }}
      >
        <ul>
          <li>classificar o tipo de mudança;</li>
          <li>avaliar se o risco é aceitável;</li>
          <li>confirmar se todas as etapas obrigatórias foram cumpridas.</li>
        </ul>
      </div>

      <div className="col-md-12 fontS-18" style={{ marginBottom: 40, paddingBottom: 5 }}
      >
        <p>
          Se a resposta for <strong>“não”</strong>, o processo volta, pede ajustes ou é interrompido.
          Isso não é falha, mas, o MOC funcionando para garantir controle, segurança e conformidade.
        </p>

      </div>
    </div>
  );
};

export default Page24;